import { Currency } from "@types";
import { CardType } from "kz-ui-sdk";

/**
 * Default card types for Peru bank accounts
 * Used as fallback when server doesn't provide cardTypes in funding profile settings
 */
export const DEFAULT_CARD_TYPES: CardType[] = [CardType.Saving, CardType.Checking];

export const CARD_TYPE_DISPLAY_ORDER: CardType[] = [CardType.Saving, CardType.Checking, CardType.Wallet];

export const sortCardTypes = (types: CardType[]): CardType[] => {
  const rank = (type: CardType) => {
    const index = CARD_TYPE_DISPLAY_ORDER.indexOf(type);
    return index === -1 ? CARD_TYPE_DISPLAY_ORDER.length : index;
  };
  return [...types].sort((a, b) => rank(a) - rank(b));
};

export type BankInfoFormFields =
  | "name"
  | "bank"
  | "accountNumber"
  | "pan"
  | "paymentMethod"
  | "upi"
  | "cpf"
  | "pixKey"
  | "curp"
  | "clabeNumber"
  | "pid"
  | "bankTypeOption"
  | "ifsc"
  | "cci"
  | "cardType";

export type BankInfoFormFieldItem =
  | BankInfoFormFields
  | [BankInfoFormFields, { options: string[] }]
  | [BankInfoFormFields, { options: string[] }, { options: string[] }];

/**
 * Bank funding profile form field configuration per currency
 * Defines which fields are required/available for each currency's bank account form
 */
export const BANK_INFO_FORM_FIELDS: Record<Currency, BankInfoFormFieldItem[]> = {
  [Currency.THB]: ["name", "bank", "accountNumber"],
  [Currency.PHP]: ["name", "bank", "accountNumber"],
  [Currency.IDR]: ["name", "bank", "accountNumber"],
  [Currency.BDT]: ["name", "bank", "accountNumber"],
  [Currency.PKR]: ["name", "bank", "accountNumber"],
  [Currency.INR]: [
    [
      "bankTypeOption",
      {
        options: ["upi", "bank"],
      },
    ],
    "name",
    "pan",
    "accountNumber",
    "ifsc",
  ],
  [Currency.BRL]: ["name", "pixKey", "cpf"],
  [Currency.MXN]: ["name", "curp", "clabeNumber"],
  [Currency.PEN]: ["name", "bank", "pid", "cardType", "accountNumber", "cci"],
  [Currency.EGP]: ["name", "bank", "accountNumber"],
  [Currency.COP]: ["name", "bank", "pid", "cardType", "accountNumber"],
};

export type EWalletInfoFormFields = "name" | "accountNumber" | "pan" | "cpf" | "curp" | "pid";

export type EWalletInfoFormFieldItem = EWalletInfoFormFields | [EWalletInfoFormFields, { options: string[] }];

/**
 * E-wallet funding profile form field configuration per currency
 * Defines which fields are required/available for each currency's e-wallet form
 */
export const EWALLET_INFO_FORM_FIELDS: Record<Currency, EWalletInfoFormFieldItem[]> = {
  [Currency.THB]: ["name", "accountNumber"],
  [Currency.PHP]: ["name", "accountNumber"],
  [Currency.IDR]: ["name", "accountNumber"],
  [Currency.BDT]: ["name", "accountNumber"],
  [Currency.PKR]: ["name", "accountNumber"],
  [Currency.INR]: ["name", "accountNumber"],
  [Currency.BRL]: ["name", "accountNumber"],
  [Currency.MXN]: ["name", "accountNumber"],
  [Currency.PEN]: ["name", "accountNumber"],
  [Currency.EGP]: ["name", "accountNumber"],
  [Currency.COP]: ["name", "pid", "accountNumber"],
};
